import { ActionType } from 'typesafe-actions';
import { createDataFetchActions } from '../dataFetching/generators';
import retry from '../../../common/utils/retry';
import { HELP_CENTER_IDENTIFIER } from './types';

const ARTICLE_COUNT = 3;

export const getHelpCenterArticlesActions = createDataFetchActions(
    HELP_CENTER_IDENTIFIER,
    ({ apiService }) => () => retry(() => apiService.shopApi.getHelpCenterArticles(ARTICLE_COUNT), 1)(),
    () => HELP_CENTER_IDENTIFIER
);

export type HelpCenterActions = ActionType<typeof getHelpCenterArticlesActions.actions>;
export const fetchHelpCenterArticlesIfNeeded = getHelpCenterArticlesActions.thunk;
